export default __webpack_public_path__ + "static/media/instagram.43f007cb.svg";